
import React, { useEffect, useState } from "react";


import { lineWobble } from 'ldrs'
import { getRelativePath } from "api/constants";

lineWobble.register()

const FilePreviewer = ({ furl, accept }) => {

    const imageTypes = ['jpg', 'jpeg', 'png', 'gif'];


    return (
        <>
            <div style={{ background: '#00000020', height: '80px', width: '100%', borderRadius: 4, display: 'flex', alignItems: 'flex-end' }} >

                {furl ?
                    <div className="d-flex   px-2 align-items-center" style={{ height: '80%' }}>
                        {
                            furl?.split('.').pop() === 'mp4' ?
                                <video height={55} width={'auto'} controls>
                                    <source src={getRelativePath(furl)} />
                                </video>
                                : imageTypes.includes(furl?.split('.').pop()) ?
                                    <img src={getRelativePath(furl)} height={55} width={'auto'} />
                                    :
                                    <>
                                        <img src={`/files-icons/${furl?.split('.')?.pop()}.png`} height={55} width={'auto'} />
                                    </>
                            // :
                            // <>
                            //     <div style={{}}>
                            //         <l-line-wobble
                            //             size="60"
                            //             stroke="5"
                            //             bg-opacity="0.1"
                            //             speed="1.75"
                            //             color="#2c7be5"
                            //         ></l-line-wobble>
                            //     </div>
                            // </>
                        }
                        <p className="ms-2 fw-bold">{furl?.split("\\").pop()}</p>
                    </div>
                    :
                    <div className="mb-4 text-danger ps-2">
                        No File Choosed
                    </div>
                }
            </div>
            {
                accept &&
                <p className="text-primary ps-2 " style={{fontSize: '12px'}}>
                    Accepted Files: {accept}
                </p>
            }
        </>
    );
};

export default FilePreviewer;